"use client"

import { useEffect } from "react"

export default function FireWebEngageEvents(props) {

  const extractNumber = (input) => {
    const match = input.match(/\d+/g); // Extracts all numbers found in the string
    return match ? String(match.join('')) : null;
  }

    useEffect(() => {
      let noOfSemester = "";
      const match = props?.Overview?.Description?.text.match(/(\d+)\s*semester/i);

      if (match) {
        noOfSemester = match[1];
      } else {
        console.log("No match found.");
      }

      const findPermonthText = props?.Attractions?.filter(({ Subtitle }) => Subtitle?.text?.toLocaleUpperCase().includes("PER MONTH"))
      const findLearnersText = props.Attractions?.filter(({ Subtitle }) => Subtitle?.text?.toLocaleUpperCase().includes("LEARNERS"))
      const perSemesterFee = props?.Fees?.FeesOptions?.filter(({ SecondaryHeading })=> SecondaryHeading?.toLocaleUpperCase().includes("PER SEMESTER FEE"));
      const fullProgramFee = props?.Fees?.FeesOptions?.filter(({ SecondaryHeading })=> SecondaryHeading?.toLocaleUpperCase().includes("FULL PROGRAM FEE"));

      window?.webengage?.track("Program Viewed", {
        "Program Name": props?.BannerSlider?.Heading?.text || "",
        "Program Type": props?.BannerSlider?.ProgramType?.text || "",
        "Fees Per Month": findPermonthText?.[0]?.Title?.text || "",
        "Total Learners": findLearnersText?.[0]?.Title?.text || "",
        "Admission Open For": props?.Attractions[2]?.Subtitle?.text || "",
        "Per Semester Fees": perSemesterFee?.[0]?.FeesInInr || "",
        "Full Program Fees": fullProgramFee?.[0]?.FeesInInr || "",
        "Program Advantages": (props.ProgramHighlights?.ImageList || []).map(({
          Subtitle, 
          Title
          })=>({ Subtitle, Title })),
        "Fee EMI Tenure": extractNumber(props?.Fees?.FeesOptions[0].SecondaryHeading || ""),
        "Number of Semesters": noOfSemester,
        "Number of Years": props?.BannerSlider?.Duration?.text || "",
      });

    }, []);

  return null
  
}
